<div class="dialog-header">
  <div class="dialog-title">
    <div style="display: flex; align-items: center;">
      <mat-icon class="dialog-icon">live_help</mat-icon>
      {{data.frage.FrageString}}
    </div>
  </div>
  <button mat-icon-button class="close-button" [mat-dialog-close]="false">
    <mat-icon class="close-icon">close</mat-icon>
  </button>
</div>

<mat-divider></mat-divider>

<div mat-dialog-content>
  @if (dossierInfo) {
    <div class="outline-blue" style="margin: 4px 0px 24px;padding: 8px;">
      <b>{{'Rückfragen.InkassoRef' | translate}}</b>: {{dossierInfo.DossierNr}}<BR>
      <b>{{'Rückfragen.Schuldner' | translate}}</b>: {{getSchuldner()}}<BR>
      <b>{{'Rückfragen.BetragForderung' | translate}}</b>: CHF {{getBetrag().toFixed(2)}}<BR>
      <b>{{'Rückfragen.Referenz' | translate}}</b>: {{getReferenz()}}
      @if (getKundennr()) {
        <div>
          <b>{{'Rückfragen.Kundennummer' | translate}}</b>: {{getKundennr()}}
        </div>
      }
    </div>
  }

  <div [innerHTML]="'&lt;style: width:60%;>' + this.oroservice.getCaption(data.frage.Texte) + '&lt;/style>'"></div>

  <!-- Direktzahlung-->
  @if (this.data.frage?.Art == 12 || this.data.frage?.Art == 26 || this.data.frage?.Art == 27 || this.data.frage?.Art == 28) {
    <div
      >
      @if (this.data.frage?.DokumentId > 0) {
        <div>
          @if (this.data.frage.DokumentId > 0) {
            <button color="primary" mat-button matSuffix class="button-dialog"
              (click)="this.oroservice.OpenDocument(this.data.frage.DokumentId, 'Zahlungsnachweis')"
              style="margin:0px">
              <mat-icon>attach_file</mat-icon>{{'Startseite.Anhang' | translate}}
            </button>
          }
        </div>
      }
    </div>
  }

  <!-- Reklamation-->
  @if (this.data.frage?.Art == 13) {
    <div>
      @if (this.data.frage?.DokumentId > 0) {
        <div>
          @if (this.data.frage.DokumentId > 0) {
            <button color="primary" mat-button matSuffix class="button-dialog"
              (click)="this.oroservice.OpenDocument(this.data.frage.DokumentId, 'Anhänge')" style="margin:0px">
              <mat-icon>attach_file</mat-icon>{{'Startseite.Anhang' | translate}}
            </button>
          }
        </div>
      }
    </div>
  }

  @if (this.data.frage?.Art != 29) {
    <div>
      <mat-radio-group [(ngModel)]="this.data.frage.Antwort"
        style="display: flex; flex-direction: column; margin-top: 24px;">
        @for (antwort of (this.oroservice.getCaptionAnswer(data.frage.Texte)); track antwort; let i = $index) {
          <mat-radio-button color="primary"
            [value]="i+1">
            <span style="word-wrap: normal; white-space: normal;">{{antwort}}</span>
          </mat-radio-button>
        }
      </mat-radio-group>
    </div>
  }

  <!-- Adressrecherche-->
  @if (this.data.frage?.Art == 11) {
    <div class="row no-padding">
      @if (this.data.frage.Antwort ===1) {
        <div class="no-padding" style="margin: 12px 0px 0px 0px;">
          <mat-checkbox color="primary" [(ngModel)]="this.data.frage.ausland" class="no-padding">
            {{'Startseite.Auslandverzogen' | translate}}
          </mat-checkbox>
          @if (!this.data.frage.ausland) {
            <div class="row no-padding" style="margin: 12px 0px 0px 0px;">
              <div class="row no-padding">
                <div class="col-md-8 col-left">
                  <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                    <mat-label>{{'Anschrift1' | translate}}</mat-label>
                    <input matInput [(ngModel)]="this.data.frage.Standort.Anschrift" type="text">
                  </mat-form-field>
                </div>
                <div class="col-md-4 col-right">
                  <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                    <mat-label>{{'Hausnummer' | translate}}</mat-label>
                    <input matInput [(ngModel)]="this.data.frage.Standort.Hausnummer" type="text">
                  </mat-form-field>
                </div>
              </div>
              <div class="row no-padding">
                <div class="col-md-4 col-left">
                  <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                    <mat-label>{{'Postfach' | translate}}</mat-label>
                    <input matInput [(ngModel)]="this.data.frage.Standort.Postfach" type="text">
                  </mat-form-field>
                </div>
                <div class="col-md-8 col-right">
                  <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                    <mat-label>{{'Adresszusatz' | translate}}</mat-label>
                    <input matInput [(ngModel)]="this.data.frage.Standort.Adresszusatz" type="text">
                  </mat-form-field>
                </div>
              </div>
              <div class="row no-padding">
                <app-postal-code [(Ort)]="this.data.frage.Standort.Ort" [(Plz)]="this.data.frage.Standort.Plz"
                  [(Land)]="this.data.frage.Standort.Land" class="row no-padding">
                </app-postal-code>
              </div>
            </div>
          }
        </div>
      }
    </div>
  }

  <!-- Direktzahlung TRV-->
  @if (this.data.frage?.Art == 29) {
    <div>
      <div class="row no-padding" style="margin-bottom: 8px;">
        <mat-radio-group [(ngModel)]="this.data.frage.Antwort"
          style="display: flex; flex-direction: column; margin-top: 24px;">
          @for (antwort of (this.getCaptionAnswerDirektzahlungTRV(data.frage.Texte)); track antwort; let i = $index) {
            <mat-radio-button color="primary"
              [value]="i+1">
              <span style="word-wrap: normal; white-space: normal;">{{antwort}}</span>
            </mat-radio-button>
          }
        </mat-radio-group>
      </div>
      @if (this.data.frage.Antwort == 2) {
        <div class="row no-padding" style="margin-bottom: 8px;">
          <mat-radio-group [(ngModel)]="this.data.frage.Option"
            style="display: flex; flex-direction: column; margin-top: 24px;">
            @for (option of (this.getCaptionOptionDirektzahlungTRV(data.frage.Texte)); track option; let io = $index) {
              <mat-radio-button color="primary"
                [value]="io + 1">
                <span style="word-wrap: normal; white-space: normal;">{{option}}</span>
              </mat-radio-button>
            }
          </mat-radio-group>
        </div>
      }
      @if (this.data.frage.Antwort == 3) {
        <div class="row no-padding" style="margin-bottom: 8px;">
          <mat-form-field appearance="fill" class="input-field" style="width:180px" floatLabel="always">
            <mat-label>{{'Betrag' | translate}}</mat-label>
            <input matInput [(ngModel)]="this.data.frage.DirektzahlungsbetragTRV" required type="number"
              autocomplete='off'>
              <span matPrefix>CHF&nbsp;</span>
            </mat-form-field>
          </div>
        }
      </div>
    }

    <!-- Rechtsvorschlag beseitigeen-->
    @if (this.data.frage?.Art == 15 && this.data.frage.DokumentId > 0) {
      <div>
        <button mat-button color="primary" matSuffix class="button-dialog"
          (click)="this.oroservice.OpenDocument(this.data.frage.DokumentId, 'Begründung RV')"
          style="margin:0px; font-size:14px;">
          <mat-icon>attach_file</mat-icon>
          {{'Dokumente.BegruendungRV' | translate}}
        </button>
      </div>
    }

    <!-- Rückfrage Rechnungskopie-->
    @if (this.data.frage?.Art == 21) {
      <div>
        <div class="row no-padding">
          <div class="rmpm dropzone" style="width:260px" appDragDrop (files)="fileservice.filesDropped($event)">
            <div class="text-wrapper">
              <div class="centered">
                <mat-icon style="font-size: 64px; width:64px; height: 64px; opacity: 0.2;">publish</mat-icon>
                <BR>
                {{'Drag' | translate}}
              </div>
            </div>
          </div>
          <div class="col">
            <button mat-button matSuffix class="button-dialog" (click)="fileMultiInput.click()">
              <mat-icon>attach_file</mat-icon> {{'Dateiauswaehlen' | translate}}
            </button>
            @if (this.fileservice.files.length > 3) {
              <button mat-button matSuffix class="button-dialog"
                (click)="fileservice.removeAllFiles()">
                <mat-icon>delete</mat-icon> {{'Alle löschen' | translate}}
              </button>
            }
            <input hidden (change)="fileservice.handleMultiFileInput($event.target.files)" #fileMultiInput
              type="file" accept=".pdf,.jpg,.jpeg" id="file" multiple>
              <div class="row no-padding">
                <mat-list>
                  @for (file of fileservice.files; track file) {
                    <mat-list-item style="height:36px; font-size: 14px;">
                      <mat-icon>picture_as_pdf</mat-icon>&nbsp;
                      {{fileservice.getFileInfo(file)}}&nbsp;
                      <button mat-icon-button color="accent" matSuffix (click)="fileservice.removeFile(file)"
                        style="margin:0px">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </mat-list-item>
                  }
                </mat-list>
              </div>
              @if (fileservice.isFileTooBig) {
                <div class="row no-padding">
                  <mat-error>{{'ErrorSizeFormat' | translate}}</mat-error>
                </div>
              }
            </div>
          </div>
        </div>
      }

      <!-- Vertreter Nachhalten-->
      @if (this.data.frage?.Art == 16) {
        <div>
          @if (this.data.frage.Antwort === 1) {
            <div>
              <mat-form-field appearance="fill" class="input-field" style="width:100%; margin-top: 8px;">
                <mat-label>{{'VertreterBeziehung' | translate}}</mat-label>
                <mat-select [(ngModel)]="this.data.frage.Gp.Beziehung">
                  <!-- <mat-option [value]="0">{{'VertreterBeziehung' | translate}}</mat-option> -->
                  <mat-option [value]="20">{{'Startseite.VaterMutter' | translate}}</mat-option>
                  <mat-option [value]="23">{{'Startseite.Beistand' | translate}}</mat-option>
                  <mat-option [value]="24">{{'Startseite.GesetzlicherVertreter' | translate}}</mat-option>
                  <mat-option [value]="25">{{'Startseite.BruderSchwester' | translate}}</mat-option>
                </mat-select>
              </mat-form-field>
              @if (this.data.frage.Gp.Beziehung == 20 || this.data.frage.Gp.Beziehung == 24 || this.data.frage.Gp.Beziehung == 25) {
                <div
                  >
                  <div class="row no-padding">
                    <div class="col-md-6 col-left">
                      <mat-form-field appearance="fill" class="input-field" style="width:100%;" floatLabel="always">
                        <mat-label>{{'Stammdaten.Anrede' | translate}}</mat-label>
                        <mat-select [(ngModel)]="this.data.frage.Gp.Anrede" required
                          placeholder="{{'RequiredPlaceholder' | translate}}">
                          <mat-option [value]="1">
                            {{'Neuauftrag.Rechnungsempfaenger.Anrede.Herr' | translate}}
                          </mat-option>
                          <mat-option [value]="2">
                            {{'Neuauftrag.Rechnungsempfaenger.Anrede.Frau' | translate}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div class="col-md-6 col-right">
                      <mat-form-field appearance="fill" class="input-field" style="width:100%;" floatLabel="always">
                        <mat-label>{{'Neuauftrag.Rechnungsempfaenger.Titel' | translate}}</mat-label>
                        <mat-select [(ngModel)]="this.data.frage.Gp.Titel">
                          @for (titel of this.oroservice.kundeninfo.Titel; track titel) {
                            <mat-option [value]="titel.Id">
                              {{titel.Name}}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="row no-padding">
                    <div class="col-md-6 col-left">
                      <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                        <mat-label>{{'Vorname' | translate}}</mat-label>
                        <input matInput [(ngModel)]="this.data.frage.Gp.Vorname" required
                          placeholder="{{'RequiredPlaceholder' | translate}}" type="text" autocomplete='off'
                          minlength="2">
                        </mat-form-field>
                      </div>
                      <div class="col-md-6 col-right">
                        <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                          <mat-label>{{'Name' | translate}}</mat-label>
                          <input matInput [(ngModel)]="this.data.frage.Gp.Name" required
                            placeholder="{{'RequiredPlaceholder' | translate}}" type="text" autocomplete='off'
                            minlength="2">
                          </mat-form-field>
                        </div>
                      </div>
                      <div class="row no-padding">
                        <div class="col-md-6 col-left">
                          <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                            <mat-label>{{'Geburtsdatum' | translate}}</mat-label>
                            <input matInput style="margin: 0px"
                              [ngModel]="this.data.frage.Gp.Geburtstag | date:'dd.MM.yyyy'"
                              (ngModelChange)="this.data.frage.Gp.Geburtstag=this.oroservice.ChangeDate($event);"
                              autocomplete='off'>
                              <input type="hidden" [matDatepicker]="pickerVon"
                                [(ngModel)]='this.data.frage.Gp.Geburtstag'>
                                <mat-datepicker-toggle matSuffix [for]="pickerVon" tabindex="-1"></mat-datepicker-toggle>
                                <mat-datepicker #pickerVon></mat-datepicker>
                              </mat-form-field>
                            </div>
                            <div class="col-md-6 col-right">
                              <mat-form-field appearance="fill" class="input-field" style="width:100%;" floatLabel="always">
                                <mat-label>{{'Sprache' | translate}}</mat-label>
                                <mat-select [(ngModel)]="this.data.frage.Gp.Sprache" required>
                                  <mat-option [value]="1">DE</mat-option>
                                  <mat-option [value]="2">FR</mat-option>
                                  <!-- <mat-option [value]="3">IT</mat-option> -->
                                </mat-select>
                              </mat-form-field>
                            </div>
                          </div>
                        </div>
                      }
                      @if (this.data.frage.Gp.Beziehung == 23) {
                        <div>
                          <div class="row no-padding">
                            <mat-form-field appearance="fill" class="input-field no-padding" style="width:100%"
                              floatLabel="always">
                              <mat-label>{{'Amt' | translate}}</mat-label>
                              <input matInput [(ngModel)]="this.data.frage.Gp.Name" required
                                placeholder="{{'RequiredPlaceholder' | translate}}" type="text" autocomplete='off'
                                minlength="2">
                              </mat-form-field>
                            </div>
                            <div class="row no-padding">
                              <div class="col-md-6 col-left">
                                <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                                  <mat-label>{{'Startseite.ZustaendigePerson' | translate}}</mat-label>
                                  <input matInput [(ngModel)]="this.data.frage.Gp.ZustaendigePerson" type="text">
                                </mat-form-field>
                              </div>
                              <div class="col-md-6 col-right">
                                <mat-form-field appearance="fill" class="input-field" style="width:100%;" floatLabel="always">
                                  <mat-label>{{'Sprache' | translate}}</mat-label>
                                  <mat-select [(ngModel)]="this.data.frage.Gp.Sprache" required>
                                    <mat-option [value]="1">DE</mat-option>
                                    <mat-option [value]="2">FR</mat-option>
                                    <!--<mat-option [value]="3">IT</mat-option> -->
                                  </mat-select>
                                </mat-form-field>
                              </div>
                            </div>
                          </div>
                        }
                        @if (this.data.frage.Gp.Beziehung == 20 || this.data.frage.Gp.Beziehung == 23 || this.data.frage.Gp.Beziehung == 24 || this.data.frage.Gp.Beziehung == 25) {
                          <div
                            >
                            <div class="row no-padding">
                              <div class="col-md-8 col-left">
                                <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                                  <mat-label>{{'Anschrift1' | translate}}</mat-label>
                                  <input matInput [(ngModel)]="this.data.frage.Gp.Adresse" type="text">
                                </mat-form-field>
                              </div>
                              <div class="col-md-4 col-middle">
                                <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                                  <mat-label>{{'Hausnummer' | translate}}</mat-label>
                                  <input matInput [(ngModel)]="this.data.frage.Gp.Hausnummer" type="text">
                                </mat-form-field>
                              </div>
                            </div>
                            <div class="row no-padding">
                              <div class="col-md-4 col-left">
                                <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                                  <mat-label>{{'Postfach' | translate}}</mat-label>
                                  <input matInput [(ngModel)]="this.data.frage.Gp.Postfach" type="text">
                                </mat-form-field>
                              </div>
                              <div class="col-md-8 col-right">
                                <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                                  <mat-label>{{'Adresszusatz' | translate}}</mat-label>
                                  <input matInput [(ngModel)]="this.data.frage.Gp.Adresszusatz" type="text">
                                </mat-form-field>
                              </div>
                            </div>
                            <div class="row no-padding">
                              <app-postal-code class="no-padding" [(Ort)]="this.data.frage.Gp.Ort"
                                [(Plz)]="this.data.frage.Gp.Plz" [(Land)]="this.data.frage.Gp.Land">
                              </app-postal-code>
                            </div>
                          </div>
                        }
                      </div>
                    }
                  </div>
                }

                <!-- Reklamation-->
                @if (this.data.frage?.Art == 13) {
                  <div>
                    <!-- Beanstandung Rückforderungsbeleg -->
                    @if (this.data.frage?.Reklamationsgrund == 8) {
                      <div>
                        <mat-form-field appearance="outline" class="file-upload">
                          @if (this.fileToUpload) {
                            <mat-label>{{this.fileToUpload.name}}</mat-label>
                          } @else {
                            <mat-label>{{'Dateiauswaehlen' | translate}}</mat-label>
                          }
                          <input readonly matInput style="margin: 0px">
                          <button mat-icon-button matSuffix (click)="fileInput.click()">
                            <mat-icon>attach_file</mat-icon>
                          </button>
                          <input hidden (change)="handleFileInput($event.target.files)" #fileInput type="file" accept=".pdf"
                            id="file">
                          </mat-form-field>
                        </div>
                      }
                      <!-- RE oder Betrag -->
                      @if (this.data.frage?.Reklamationsgrund == 2 && this.data.frage?.Antwort == 3) {
                        <div style="margin-top: 12px;">
                          @for (rechnung of this.data.frage?.Rechnungen; track rechnung; let i = $index) {
                            <div>
                              <div class="row no-padding">
                                <div class="col-md-6 col-left" no-padding>
                                  <mat-form-field appearance="standard" class="input-field" style="width:100%;">
                                    <mat-label>{{'Dossier.Rechnungsnummer' | translate}}</mat-label>
                                    <input matInput [(ngModel)]="rechnung.Rechnungsnummer" readonly type="text">
                                    <mat-icon matPrefix class="icon-prefix">receipt</mat-icon>
                                  </mat-form-field>
                                </div>
                                <div class="col-md-6 col-right" no-padding>
                                  <mat-form-field appearance="fill" class="input-field" style="width:100%;">
                                    <mat-label>{{'Dossier.Betrag' | translate}}</mat-label>
                                    <input matInput [(ngModel)]="rechnung.Betrag" required
                                      pattern="[(0-9)|']+([\.,][0-9]{1,2})?" type="number">
                                      <span matPrefix>CHF&nbsp;</span>
                                    </mat-form-field>
                                  </div>
                                </div>
                              </div>
                            }
                          </div>
                        }
                        <!-- Reklamation RE -> Andere RE eintragen -->
                        @if (this.data.frage?.Reklamationsgrund == 3 && this.data.frage?.Antwort == 4) {
                          <div>
                            <BR>
                            <div class="row no-padding">
                              <div class="col-md-6 col-left">
                                <mat-form-field appearance="fill" class="input-field" style="width:100%;">
                                  <mat-label>{{'Stammdaten.Anrede' | translate}}</mat-label>
                                  <mat-select [(ngModel)]="this.data.frage.Gp.Anrede" required>
                                    <mat-option [value]="1">{{'Neuauftrag.Arzt.Anrede.Herr' | translate}}</mat-option>
                                    <mat-option [value]="2">{{'Neuauftrag.Arzt.Anrede.Frau' | translate}}</mat-option>
                                  </mat-select>
                                </mat-form-field>
                              </div>
                              <div class="col-md-6 col-right">
                                <mat-form-field appearance="fill" class="input-field" style="width:100%">
                                  <mat-label>{{'Vorname' | translate}}</mat-label>
                                  <input matInput [(ngModel)]="this.data.frage.Gp.Vorname" required type="text">
                                </mat-form-field>
                              </div>
                            </div>
                            <div class="row no-padding">
                              <div class="col-md-6 col-left">
                                <mat-form-field appearance="fill" class="input-field" style="width:100%">
                                  <mat-label>{{'Name' | translate}}</mat-label>
                                  <input matInput [(ngModel)]="this.data.frage.Gp.Name" required type="text">
                                </mat-form-field>
                              </div>
                              <div class="col-md-6 col-right">
                                <mat-form-field appearance="fill" class="input-field" style="width:100%">
                                  <mat-label>{{'Geburtsdatum' | translate}}</mat-label>
                                  <input matInput style="margin: 0px"
                                    [ngModel]="this.data.frage.Gp.Geburtstag | date:'dd.MM.yyyy'"
                                    (ngModelChange)="this.data.frage.Gp.Geburtstag=this.oroservice.ChangeDate($event);"
                                    autocomplete='off'>
                                    <input type="hidden" [matDatepicker]="pickerVon" [(ngModel)]='this.data.frage.Gp.Geburtstag'>
                                    <mat-datepicker-toggle matSuffix [for]="pickerVon" tabindex="-1"></mat-datepicker-toggle>
                                    <mat-datepicker #pickerVon></mat-datepicker>
                                  </mat-form-field>
                                </div>
                              </div>
                              <div class="row no-padding">
                                <div class="col-md-8 col-left">
                                  <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                                    <mat-label>{{'Anschrift1' | translate}}</mat-label>
                                    <input matInput [(ngModel)]="this.data.frage.Gp.Adresse" type="text">
                                  </mat-form-field>
                                </div>
                                <div class="col-md-4 col-right">
                                  <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                                    <mat-label>{{'Hausnummer' | translate}}</mat-label>
                                    <input matInput [(ngModel)]="this.data.frage.Gp.Hausnummer" type="text">
                                  </mat-form-field>
                                </div>
                              </div>
                              <div class="row no-padding">
                                <div class="col-md-4 col-left">
                                  <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                                    <mat-label>{{'Postfach' | translate}}</mat-label>
                                    <input matInput [(ngModel)]="this.data.frage.Gp.Postfach" type="text">
                                  </mat-form-field>
                                </div>
                                <div class="col-md-8 col-right">
                                  <mat-form-field appearance="fill" class="input-field" style="width:100%" floatLabel="always">
                                    <mat-label>{{'Adresszusatz' | translate}}</mat-label>
                                    <input matInput [(ngModel)]="this.data.frage.Gp.Adresszusatz" type="text">
                                  </mat-form-field>
                                </div>
                              </div>
                              <div class="row no-padding">
                                <app-postal-code class="no-padding" [(Ort)]="this.data.frage.Gp.Ort" [(Plz)]="this.data.frage.Gp.Plz"
                                [(Land)]="this.data.frage.Gp.Land" [Marginfull]="false"></app-postal-code>
                              </div>
                            </div>
                          }
                          @if (this.data.frage?.Reklamationsgrund != 3) {
                            <mat-form-field appearance="fill"
                              style="width: 100%; margin-top: 8px;">
                              <mat-label>{{'Begründung' | translate}}</mat-label>
                              <textarea matInput cdkTextareaAutosize rows="5" [(ngModel)]="this.data.frage.Begruendung">
                              </textarea>
                            </mat-form-field>
                          }
                        </div>
                      }

                      <!-- Direktzahlung-->
                      @if (this.hasDirektZahlung()) {
                        <div>
                          @for (rechnung of data.frage?.Rechnungen; track rechnung; let i = $index) {
                            <div>
                              <div class="row no-padding">
                                <div class="col-md-4 col-left">
                                  <mat-form-field appearance="fill" class="login-form-field" style="width: 100%">
                                    <mat-label>{{'Rechnungsnummer' | translate}}</mat-label>
                                    <input matInput [(ngModel)]="rechnung.Rechnungsnummer" style="margin: 0px" readonly="true">
                                    <button mat-flat-button color="primary" matPrefix (click)="direktZahlungAdd(rechnung, i)"
                                      matTooltip="{{'Dossier.PlusTooltip' | translate}}" class="icon-button">
                                      <mat-icon style=" padding:0px; margin: 0px">add</mat-icon>
                                    </button>
                                    @if (data.frage?.Rechnungen.length > 1) {
                                      <button mat-button matSuffix mat-icon-button
                                        aria-label="Remove" (click)="direktZahlungRemove(i)">
                                        <mat-icon style="color:darkred">close</mat-icon>
                                      </button>
                                    }
                                  </mat-form-field>
                                </div>
                                <div class="col-md-4 col-middle">
                                  <mat-form-field appearance="fill" style="width:100%" class="custom-chf-prefix">
                                    <mat-label>{{'Dossier.Betrag' | translate}}</mat-label>
                                    <input matInput [(ngModel)]="rechnung.Betrag" required autocomplete='off'
                                      pattern="[(0-9)|']+([\.,][0-9]{1,2})?" type="number">
                                      <span matPrefix>CHF&nbsp;</span>
                                    </mat-form-field>
                                  </div>
                                  <div class="col-md-4 col-right">
                                    <mat-form-field appearance="fill" style="width: 100%">
                                      <mat-label>{{'Dossieransicht.Zahldatum' | translate}}</mat-label>
                                      <input matInput style="margin: 0px" [ngModel]="rechnung.Zahldatum | date:'dd.MM.yyyy'"
                                        (ngModelChange)="rechnung.Zahldatum=this.oroservice.ChangeDate($event);" required
                                        placeholder="{{'RequiredPlaceholder' | translate}}" autocomplete='off'>
                                        <input type="hidden" [matDatepicker]="picker" [(ngModel)]='rechnung.Zahldatum'>
                                        <mat-datepicker-toggle matSuffix [for]="picker" tabindex="-1"></mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                      </mat-form-field>
                                    </div>
                                    @if (checkDirektzahlungsDatumZukunft(rechnung.Zahldatum)) {
                                      <div class="col-md-12 warning no-padding"
                                        style="text-align: right">
                                        {{'DatumZukunft' | translate}}
                                      </div>
                                    }
                                  </div>
                                </div>
                              }
                            </div>
                          }

                          <div class="answer-button-row">
                            <button mat-flat-button color="primary" class="button-dialog answer-button" (click)="answer()"
                              [disabled]="isUpdating || !this.canSubmit()" style="margin-top: 8px;">
                              {{'Rückfragen.Antworten' | translate}}
                              @if (isUpdating) {
                                <mat-spinner diameter="20" style="margin-left: 8px;"></mat-spinner>
                              }
                            </button>
                          </div>
                        </div>

                        <!-- <div *ngIf="this.fragen != undefined ? this.fragen?.length > 0 : false">
                        <app-button (click)=" answer()">
                          {{'Rückfragen.Antworten' | translate}}
                        </app-button>
                      </div> -->

                      <!-- <div mat-dialog-actions>
                      <button mat-flat-button color="primary" class="button-dialog"
                      [mat-dialog-close]=false>{{'schliessen' | translate}}</button>
                    </div> -->
